import * as React from "react";

const EnvalopeIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={16}
    viewBox="0 0 17 16"
    fill="none"
    {...props}
  >
    <path
      fill="#F97316"
      d="M14 3H3a1 1 0 0 0-1 1v10a.99.99 0 0 0 .578.906.994.994 0 0 0 1.07-.15L5.657 13H14a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1Zm-3.5 6.5h-4a.5.5 0 1 1 0-1h4a.5.5 0 1 1 0 1Zm0-2h-4a.5.5 0 1 1 0-1h4a.5.5 0 1 1 0 1Z"
    />
  </svg>
);
export default EnvalopeIcon;
